var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "text-gray-500 text-base",
    class: _vm.classList
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }